// extracted by mini-css-extract-plugin
module.exports = {"customAccordionContainer":"ServiceClientsToggle_customAccordionContainer__3nOuK","accordionToggle":"ServiceClientsToggle_accordionToggle__EFThb"};